import { render, staticRenderFns } from "./service-status.vue?vue&type=template&id=670133a9&scoped=true"
import script from "./service-status.vue?vue&type=script&lang=ts"
export * from "./service-status.vue?vue&type=script&lang=ts"
import style0 from "./service-status.vue?vue&type=style&index=0&id=670133a9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670133a9",
  null
  
)

export default component.exports